export default __webpack_public_path__ + "static/media/caf-logo-extended.7b3f546e.svg";